import { Link } from "react-router-dom";

export const TopFightersLeaderboard = ({ players }) => {
  if (!players || players.length === 0) return null;

  return (
    <div>
      <h2 className="font-heading text-lg font-bold uppercase tracking-wider text-white mb-3">Top Fighters</h2>
      <div className="space-y-2">
        {players.map((player, index) => (
          <Link
            key={player.PlayerID}
            to={`/player/${player.PlayerID}`}
            className="flex items-center justify-between bg-flyers-charcoal/50 border border-flyers-dark-gray rounded px-4 py-3 hover:border-flyers-orange/50 transition-colors duration-150"
          >
            <div className="flex items-center gap-3">
              <span className="text-flyers-orange font-heading font-black w-6 text-center">{index + 1}</span>
              <span className="text-white">
                {player.firstName} {player.lastName}
              </span>
            </div>
            <span className="text-flyers-mid-gray text-sm">
              {player.wins || 0}W - {player.losses || 0}L
              {player.draws ? ` - ${player.draws}D` : ""}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};
